import axios from 'axios';

const healthClient = axios.create({
	baseURL: process.env.VUE_APP_API_URL,
	timeout: 10000,
});

export const checkHealthAPI = () => healthClient.get('/health');
